import { NgModule } from '@angular/core';
import { AccessCodeAddDispatcher } from '@spaq/core/dispatchers/access-code-add-dispatcher';
import { AccessCodeDetailsDispatcher } from '@spaq/core/dispatchers/access-code-details-dispatcher';
import { CalendarDispatcher } from '@spaq/core/dispatchers/calendar-dispatcher';
import { FaqDispatcher } from '@spaq/core/dispatchers/faq-dispatcher';
import { LayoutDispatcher } from '@spaq/core/dispatchers/layout-dispatcher';
import { OrganizationDispatcher } from '@spaq/core/dispatchers/organization-dispatcher';
import { ParksDispatcher } from '@spaq/core/dispatchers/parks-dispatcher';
import { ProfileDetailsDispatcher } from '@spaq/core/dispatchers/profile-details-dispatcher';
import { ProfileDispatcher } from '@spaq/core/dispatchers/profile-dispatcher';
import { ProfileEditDispatcher } from '@spaq/core/dispatchers/profile-edit-dispatcher';
import { RegisterDispatcher } from '@spaq/core/dispatchers/register-dispatcher';
import { SectorsDispatcher } from '@spaq/core/dispatchers/sectors-dispatcher';
import { SubscriptionDetailsDispatcher } from '@spaq/core/dispatchers/subscription-details-dispatcher';
import { SubscriptionDispatcher } from '@spaq/core/dispatchers/subscription-dispatcher';
import { SubscriptionEditDispatcher } from '@spaq/core/dispatchers/subscription-edit-dispatcher';
import { VehiclesAddDispatcher } from '@spaq/core/dispatchers/vehicles-add-dispatcher';
import { VehiclesDispatcher } from '@spaq/core/dispatchers/vehicles-dispatcher';
import { VehiclesEditDispatcher } from '@spaq/core/dispatchers/vehicles-edit-dispatcher';

@NgModule({
	imports: [],
	declarations: [],
	providers: [
		CalendarDispatcher,
		FaqDispatcher,
		LayoutDispatcher,
		OrganizationDispatcher,
		ParksDispatcher,
		ProfileDispatcher,
		ProfileEditDispatcher,
		ProfileDetailsDispatcher,
		RegisterDispatcher,
		SectorsDispatcher,
		SubscriptionEditDispatcher,
		SubscriptionDispatcher,
		SubscriptionDetailsDispatcher,
		AccessCodeAddDispatcher,
		AccessCodeDetailsDispatcher,
		VehiclesDispatcher,
		VehiclesAddDispatcher,
		VehiclesEditDispatcher
	]
})
export class DispatchersModule {}
